<template>
    <div class='commonPag'>
        <el-pagination :background="background" :page-size="pageSize" layout="total, prev, pager, next" :total="total"
            :current-page="currentPage" @size-change="onSizeChange" @current-change="currentChange" />
    </div>
</template>

<script>
export default {
    name: '',
    components: {},
    props: {
        background: {
            type: Boolean,
            default: true
        },
        total: {
            type: Number,
            default: 0
        },
        currentPage: {
            type: Number,
            default: 1
        },
        pageSize: {
            type: Number,
            default: 5
        }
    },
    data() {
        return {
        };
    },
    watch: {},
    computed: {},
    created() { },
    mounted() { },
    methods: {
        currentChange(current) {
            this.$emit('currentChange', { currentPage: current })
        },
        onSizeChange(pageSize) {
            this.$emit('onSizeChange', { pageSize })
        }
    }
};
</script>
<style lang="less" scoped>
/deep/ .el-pagination {
    text-align: center;
    margin: 25px 0;
}
</style>


// WEBPACK FOOTER //
// src/components/commonPag.vue